import SPModuleLoaderProvider from './SPModuleLoaderProvider';
// tslint:disable-next-line:no-unused-imports
import SPModuleLoader from './SPModuleLoader'; // tslint:disable-line:no-unused-variable

export default SPModuleLoaderProvider.instance; // tslint:disable-line:export-name
export { IDeveloperToolsTab } from './DeveloperTools/IDeveloperToolsTab';
export { default as SPFlight } from './staticLinks/SPFlight';
export { default as UrlQueryParameterCollection } from './staticLinks/UrlQueryParameterCollection';



// WEBPACK FOOTER //
// /src/index.ts


// WEBPACK FOOTER //
// webpack:///src/index.ts